import React from 'react';
import {useSelector} from 'react-redux';
import {selectDisplayLayout} from '@/store/slices/layoutSlice';
import {AppBar, Box, Toolbar} from "@mui/material";

const Footer: React.FC = () => {
    const {footer} = useSelector(selectDisplayLayout);
    if (!footer) {
        return null;
    }
    return (
        <AppBar sx={{ top: 'auto', bottom: 0, display: { xs: 'none', sm: 'flex' }}} position="fixed" color="primary">
            <Toolbar>
                <Box sx={{flexGrow: 1}}>
                    <img src="/static/images/teknik-cuadrado.jpeg"/>
                </Box>
                <Box sx={{flexGrow: 1}}>2</Box>
                <Box sx={{flexGrow: 1}}>3</Box>
                <Box sx={{flexGrow: 1}}>4</Box>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;
